import React from "react";
import { Typography } from "@mui/material";

export default function Error404() {
  return <Typography>404 Page Not Found</Typography>;
}
